<template>
<div style="max-width: 1000px; margin: 0 auto;padding:10px;font-size:16px;">
<div style="margin-bottom:10vh;" id="wind" >
        <h1 class="text-h1">{{ $t("home.portfolio.case1.desc") }}</h1>
        <p>{{ $t("cases.case1.desc") }}
            
        </p>
      <img src="/statics/images/wind1.png" alt="" class="one-col">
      <img src="/statics/images/wind2.png" alt=""  class="one-col">
      <div class="two-col-container">
        <img src="/statics/images/wind3.png" alt="" class="two-col">
      <img src="/statics/images/wind4.png" alt=""  class="two-col">
    
      </div>
      <div class="two-col-container">
        <img src="/statics/images/wind5.png" alt=""  class="two-col">
      <img src="/statics/images/wind6.png" alt=""  class="two-col">
      
      </div>
      
        
      </div>

      <div  style="margin-bottom:10vh" id="industrial">
        <h1 class="text-h1">{{ $t("home.portfolio.case4.desc") }}</h1>
        <p>{{ $t("cases.case2.desc") }}
            
        </p>
             <img src="/statics/images/industrial1.png" alt="" class="one-col">
              <div class="two-col-container">
      <img src="/statics/images/industrial2.png" alt=""  class="two-col">
      <img src="/statics/images/industrial3.png" alt="" class="two-col">
              </div>
      </div>
      <div style="margin-bottom:10vh" id="ups">
        <h1 class="text-h1">{{ $t("home.portfolio.case3.desc") }}</h1>
        <p>{{ $t("cases.case3.desc") }}
        </p>
         <img src="/statics/images/ups1.png" alt="" class="one-col">
          <div class="two-col-container">
      <img src="/statics/images/ups2.png" alt="" class="two-col">
      <img src="/statics/images/ups3.png" alt="" class="two-col">
          </div>
      </div>
</div>
      

</template>
<script>
export default {
  name: "Cases",
  components: {},

  methods: {
  },
};

</script>

<style scoped>
.one-col {
    width:auto;
    max-width: 90%;
    min-width: 250px;
    max-height: 60vh;
    margin:20px auto;
    object-fit:contain;
    display: flex;
    
}
.two-col-container {
    width:auto;
    height: auto;
    margin:0 auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
}
.two-col {
    width:auto;
    max-width: 40%;
    min-width:250px;
    max-height: 60vh;
    object-fit: contain;
}
</style>
